import type { BatchErrorTransaction } from '@api/hooks/useBatch.ts';
import { Chip, InfoIcon, Typography } from '@gurupay/gp-ui-library';
import { formatNumberAmount } from '@utils/utils.ts';
import type { TFunction } from 'i18next';

export const errorRenderers = (t: TFunction) => ({
	beneficiary: ({
		error_message,
		beneficiary_account_number,
		beneficiary_name,
	}: BatchErrorTransaction) => (
		<div className="flex flex-col gap-space-8">
			<div className="flex flex-col">
				<Typography className="font-bold" level="small-text">
					{beneficiary_name}
				</Typography>
				<Typography className="font-medium text-neutral-600" level="small-text">
					{beneficiary_account_number}
				</Typography>
			</div>
			{!!error_message && (
				<span className="flex items-center gap-space-8 text-status-error-500">
					<InfoIcon className="w-space-16 h-space-16" />
					{t(error_message.replaceAll('.', '_'))}
				</span>
			)}
		</div>
	),

	description: ({ payment_details }: BatchErrorTransaction) => (
		<Typography className="font-medium break-all w-[100px] block" level="small-text">
			{payment_details}
		</Typography>
	),

	status: () => (
		<Chip color="error" label={t(`paymentStatus.error`)} size="medium" variant="filled" />
	),

	amount: ({ amount }: BatchErrorTransaction) => (
		<Typography className="font-bold" level="small-text">
			{formatNumberAmount(amount.toFixed(2))}
		</Typography>
	),
});
